import type { ComponentPropsWithRef } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'
import { fieldClassName } from './field-class'

export const Select = ({
  register,
  options,
  ...rest
}: ComponentPropsWithRef<'select'> & {
  register: UseFormRegisterReturn
  options: { label: string; value: string }[]
}) => {
  return (
    <div className="relative">
      {/* globals.css の select に background-color: transparent !important があるため ! で上書きする */}
      <select
        {...rest}
        className={`${fieldClassName} select-placeholder appearance-none bg-surface! pr-12`}
        {...register}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <span
        aria-hidden
        className="icon icon-chevron-down pointer-events-none absolute top-1/2 right-4 size-5 -translate-y-1/2 text-ink"
      />
    </div>
  )
}
